export const GET_LIVE_FEEDBACK_QUESTIONS = "GET_LIVE_FEEDBACK_QUESTIONS";
export const GET_LIVE_FEEDBACK_QUESTIONS_SUCCESS = "GET_LIVE_FEEDBACK_QUESTIONS_SUCCESS";
export const GET_LIVE_FEEDBACK_QUESTIONS_ERROR = "GET_LIVE_FEEDBACK_QUESTIONS_ERROR";
